import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#eeeeee] text-gray-600 overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-8 py-12">
        {/* 1행: 로고 가운데 정렬 */}
        <div className="mb-10 flex justify-center">
          <img
            src="/logo-full.png"
            alt="동두천시 글로벌인재교육센터"
            className="h-12 w-auto"
          />
        </div>

        {/* 2행: 좌측 기관정보(한/영) ↔ 우측 빠른링크·고객지원 */}
        <div className="flex flex-col lg:flex-row lg:items-start gap-10 lg:gap-16 mb-10">
          {/* 좌측: 기관정보 — 한국어 + 영어 (행 단위 정렬: subgrid) */}
          <div className="lg:flex-1 grid grid-cols-1 sm:grid-cols-[auto_auto] gap-y-8 sm:gap-y-2 gap-x-10 lg:gap-x-14 sm:grid-rows-[repeat(6,auto)]">
            {/* 한국어 기관정보 */}
            <div className="grid gap-y-2 text-sm sm:row-span-6 sm:grid-rows-[subgrid]">
              <p className="text-gray-800 font-semibold text-base">㈜한원글로벌 동두천 글로벌인재교육센터</p>
              <p>대표: 김한경</p>
              <p>주소: 경기도 동두천시 동두천로 97, 2층</p>
              <p>이메일: <a href="mailto:korea@hanwonglobal.com" className="hover:text-green-600 transition-colors">korea@hanwonglobal.com</a></p>
              <p>전화: <a href="tel:+82318665670" className="hover:text-green-600 transition-colors">031-866-5670</a></p>
              <p>팩스: 031-866-5671</p>
            </div>

            {/* 영어 기관정보 */}
            <div className="grid gap-y-2 text-sm sm:max-w-[36rem] sm:row-span-6 sm:grid-rows-[subgrid]">
              <p className="text-gray-800 font-semibold text-base">Hanwon Global Co., Ltd. Dongducheon Global Talent Center</p>
              <p>CEO: Kim, Hangyeong</p>
              <p>Address: 2F, 97 Dongducheon-ro, Dongducheon-si, Gyeonggi-do, Republic of Korea</p>
              <p>Email: <a href="mailto:korea@hanwonglobal.com" className="hover:text-green-600 transition-colors">korea@hanwonglobal.com</a></p>
              <p>Tel: <a href="tel:+82318665670" className="hover:text-green-600 transition-colors">+82-31-866-5670</a></p>
              <p>Fax: +82-31-866-5671</p>
            </div>
          </div>

          {/* 우측: 빠른링크 + 고객지원 */}
          <div className="flex gap-12 lg:gap-16 shrink-0">
            {/* 빠른 링크 */}
            <div>
              <h3 className="text-gray-800 font-bold text-base mb-3">빠른 링크</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/about/greeting" className="hover:text-green-600 transition-colors">센터소개</Link>
                </li>
                <li>
                  <Link to="/curriculum" className="hover:text-green-600 transition-colors">교육과정</Link>
                </li>
                <li>
                  <Link to="/notice" className="hover:text-green-600 transition-colors">공지사항</Link>
                </li>
                <li>
                  <Link to="/about/location" className="hover:text-green-600 transition-colors">오시는 길</Link>
                </li>
              </ul>
            </div>

            {/* 고객지원 */}
            <div>
              <h3 className="text-gray-800 font-bold text-base mb-3">고객지원</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/community/faq" className="hover:text-green-600 transition-colors">자주묻는 질문</Link>
                </li>
                <li>
                  <Link to="/application/register" className="hover:text-green-600 transition-colors">수강신청</Link>
                </li>
                <li>
                  <Link to="/mypage" className="hover:text-green-600 transition-colors">마이페이지</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 3행: 카피라이트(좌) ↔ SNS(우) — 바닥 무게중심 */}
        <div className="border-t border-gray-300 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-sm text-gray-500 text-center md:text-left">
            &copy; {new Date().getFullYear()} Dongducheon Global Talent Center. All rights reserved.
          </p>
          <div className="flex items-center gap-3 justify-center md:justify-end">
            <a
              href="https://www.youtube.com/@ddcglobalcenter"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
              aria-label="YouTube"
            >
              <img src="/youtube.png" alt="YouTube" className="h-9 w-auto object-contain" />
            </a>
            <a
              href="https://www.instagram.com/help.dgtc/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
              aria-label="Instagram"
            >
              <img src="/instagram.png" alt="Instagram" className="h-14 w-auto object-contain" />
            </a>
            <a
              href="http://pf.kakao.com/_xdWzpn"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-70 transition-opacity"
              aria-label="KakaoTalk"
            >
              <img src="/kakaotalk-new.png" alt="KakaoTalk" className="h-8 w-auto object-contain" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
